import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeBottom32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconEdgeBottom32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25.5 11.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M24.25 15a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0m-19 0a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0m20.25 6.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M5.25 20a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0m14-14a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M10.5 7.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5M14.25 6a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M6.5 11.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m3.25 13.5a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeBottom32);
